import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import {
  Button,
  Card,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap';
import { getLawyerAiChatId, getSubscription } from '../../entities/case-forms/case-lawyer.reducer';
import { createLawyerForms, saveLawyerForms } from '../../entities/case-forms/case-lawyer.reducer';
import { useNavigate } from 'react-router';
import Stepperform from '../../shared/layout/stepperform/stepperform';
import FooterComponent from '../../shared/layout/footer/footer';
import { Skeleton } from './skeleton';
const CaseLawyer = props => {
  const dispatch = useAppDispatch();
  const { id } = useAppSelector(state => state.authentication?.account);
  const { entities, loading } = useAppSelector(state => state.caseLawyer);
  const aiChatId = useAppSelector(state => state.caseLawyer.entity.data);
  const [loader, setLoader] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [isLoading, setIsLoading] = useState<any>(true || loading);
  const [saveMessage, setSaveMessage] = useState<any>('');
  const [formData, setFormData] = useState<any>([]);
  const [formValues, setFormValues] = useState<any>({});
  const [dropdownStates, setDropdownStates] = useState({});
  const get_ai_id: any = localStorage.getItem('ai_id');
  const initalAiId = JSON.parse(get_ai_id);
  const [plan, setPlan] = useState<any>('');
  const navigate = useNavigate();
  const endDate = plan?.endDate ? new Date(plan?.endDate) : null;
  const now = new Date();
  const isExpired = endDate ? now > endDate : false;
  const startDate = plan?.startDate ? new Date(plan.startDate) : null;

  useEffect(() => {
    const checkSubscription = async () => {
      const isActive = await getSubscription(id);
      setPlan(isActive || '');
    };
    checkSubscription();
  }, []);

  useEffect(() => {
    dispatch(getLawyerAiChatId(id));
    setSaveMessage('');
  }, [id]);

  const getforms = async () => {
    aiChatId && (await dispatch(createLawyerForms(aiChatId)));
  };

  const getformFields = () => {
    const initialValues = {};
    entities?.forEach(field => {
      initialValues[field.name] = field.value || '';
    });
    setFormValues(initialValues);
    setFormData(entities || []);
    entities && setIsLoading(false);
  };

  useEffect(() => {
    getforms();
  }, [aiChatId]);

  useEffect(() => {
    getformFields();
  }, [entities]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormValues(prevValues => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleMutliSelect = (name, selectedOption) => {
    setFormValues(prev => {
      const currentStr = prev[name] || '';
      const currentArr = currentStr ? currentStr.split(',') : [];

      const updatedArr = currentArr.includes(selectedOption)
        ? currentArr.filter(item => item !== selectedOption)
        : [...currentArr, selectedOption];

      return {
        ...prev,
        [name]: updatedArr.join(','),
      };
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoader(true);
    const formList = formData.map(field => ({
      name: field.name,
      value: formValues[field.name] || '',
      type: field.type,
      formInputType: field.formInputType,
      options: field.options || null,
    }));

    const payload = {
      aiChatId: initalAiId,
      formList: formList,
    };

    try {
      setIsLoading(true);
      setSaveMessage('Please wait, we are saving your information...');
      await dispatch(saveLawyerForms(payload)).then((mes: any) => {
        if (mes?.payload?.data?.status === 'error') {
          toast.error(mes?.payload?.data?.message, {
            position: 'top-right',
          });
        } else {
          toast.success(mes?.payload?.data?.message, {
            position: 'top-right',
          });
          const currentStep = 2;
          const existingStr = localStorage.getItem('submittedstep');
          const existing = existingStr ? JSON.parse(existingStr) : {};

          const userSteps = existing[id] || [];
          if (!userSteps.includes(currentStep)) {
            userSteps.push(currentStep);
            existing[id] = userSteps;
            localStorage.setItem('submittedstep', JSON.stringify(existing));
            localStorage.setItem('step', JSON.stringify(3));
          }
          if (isExpired) {
            navigate('/plan');
            return;
          }
          const excludedPlans = ['Free', 'Free Access'];
          if (plan !== '' && !excludedPlans.includes(plan?.name)) {
            navigate('/evidence');
          } else {
            navigate('/plan');
          }
        }
      });
    } catch (error) {
      toast.error('Something went wrong', {
        position: 'top-right',
      });
      setSaveMessage('');
    }
    setIsLoading(false);
    setLoader(false);
  };

  const toggleDropdown = fieldName => {
    setDropdownStates(prevState => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };

  const handleSelect = (name, selectedOption) => {
    setFormValues(prevValues => ({
      ...prevValues,
      [name]: selectedOption,
    }));
  };

  return (
    <>
      <div className="main-content flex-grow-1 d-flex flex-column gap-5 justify-content-between px-4 pb-4">
        <div className="custom-container flex-grow-1">
          <h1 className="page-title">Case Details Form</h1>
          <Stepperform />
          <Card className="card-wrapper">
            <h3 className="form-title">Lawyer's Questions Screen</h3>
            <p> Complete the questions below</p>
            {!isLoading ? (
              <Form onSubmit={handleSubmit}>
                <Row>
                  {formData
                    ?.filter(
                      field =>
                        field.displayNumber !== null &&
                        field.displayNumber !== undefined &&
                        field.displayNumber !== 11 &&
                        field.displayNumber !== 12,
                    )
                    ?.sort((a, b) => a.displayNumber - b.displayNumber)
                    ?.map((field, index) => (
                      <Col md="6" key={index} className="mb-3">
                        <FormGroup className="position-relative">
                          <Label for={field.name}>{field?.name.charAt(0).toUpperCase() + field.name.slice(1)}</Label>
                          {field.formInputType === 'TEXTAREA' ? (
                            <Input
                              type="textarea"
                              name={field.name}
                              style={{ resize: 'none' }}
                              id={field.name}
                              placeholder={`${field?.displayNumber === 9 || field?.displayNumber === 10 ? 'Please enter a valid numeric value' : 'If applicable, please describe any incidents including dates.'}`}
                              value={formValues[field.name]}
                              onChange={handleChange}
                              invalid={!!errors[field.name]}
                            />
                          ) : field.formInputType === 'SELECT' ? (
                            <>
                              <Dropdown isOpen={dropdownStates[field.name] || false} toggle={() => toggleDropdown(field.name)}>
                                <DropdownToggle caret className="dropdown-toggle-custom">
                                  {formValues[field.name] ? formValues[field.name] : 'Select'}
                                </DropdownToggle>
                                <DropdownMenu className="custom-dropdown">
                                  {field.options?.split(',').map((option, optIndex) => (
                                    <DropdownItem
                                      key={optIndex}
                                      value={option}
                                      className={`custom-option ${formValues[field.name] === option ? 'selected-option' : ''}`}
                                      onClick={() => handleSelect(field.name, option)}
                                    >
                                      {option}
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </>
                          ) : field.formInputType === 'MULTISELECT' ? (
                            <Dropdown isOpen={dropdownStates[field.name] || false} toggle={() => toggleDropdown(field.name)}>
                              <DropdownToggle caret className="dropdown-toggle-custom">
                                {formValues[field.name]?.length ? formValues[field.name] : 'Select Multiple'}
                              </DropdownToggle>
                              <DropdownMenu className="custom-dropdown">
                                {field.options?.split(',').map((option, optIndex) => {
                                  const selectedValues = formValues[field.name]?.split(',') || [];
                                  const isSelected = selectedValues.includes(option);
                                  return (
                                    <DropdownItem
                                      key={optIndex}
                                      value={option}
                                      onClick={() => handleMutliSelect(field.name, option)}
                                      className={`custom-option ${isSelected ? 'selected-option' : ''}`}
                                    >
                                      {option}
                                    </DropdownItem>
                                  );
                                })}
                              </DropdownMenu>
                            </Dropdown>
                          ) : // <Input
                          //   type="select"
                          //   name={field.name}
                          //   id={field.name}
                          //   value={formValues[field.name]}
                          //   onChange={handleChange}
                          //   invalid={!!errors[field.name]}
                          // >
                          //   <option value="">Select</option>
                          //   {field.options?.split(',')?.map((option, optIndex) => (
                          //     <option key={optIndex} value={option}>
                          //       {option}
                          //     </option>
                          //   ))}
                          // </Input>
                          field?.formInputType === 'RADIO' ? (
                            field.options?.split(',')?.map((option, optIndex) => (
                              <div key={optIndex} className="form-check">
                                <Input
                                  type="radio"
                                  name={field.name}
                                  id={`${field.name}-${option}`}
                                  value={option}
                                  checked={formValues[field.name] === option}
                                  onChange={handleChange}
                                  className="form-check-input"
                                  invalid={!!errors[field.name]}
                                />
                                <Label for={`${field.name}-${option}`} className="form-check-label">
                                  {option}
                                </Label>
                              </div>
                            ))
                          ) : (
                            <Input
                              type={field?.formInputType?.toLowerCase()}
                              name={field.name}
                              id={field.name}
                              placeholder={`${field?.displayNumber === 9 || field?.displayNumber === 10 ? 'Please enter a valid numeric value' : 'If applicable, please describe any incidents including dates.'}`}
                              value={formValues[field.name]}
                              onChange={handleChange}
                              invalid={!!errors[field.name]}
                            />
                          )}
                          <FormFeedback>{errors[field.name]}</FormFeedback>
                        </FormGroup>
                      </Col>
                    ))}
                  {formData
                    ?.filter(field => field.displayNumber === 11 || field.displayNumber === 12)
                    ?.map((field, index) => (
                      <>
                        <Col lg="3" key={`date-row-${index}`} className="mb-2">
                          <Col md="12" key={field.name}>
                            <FormGroup>
                              <Label for={field.name}>{field?.name.charAt(0).toUpperCase() + field.name.slice(1)}</Label>
                              <Input
                                type={'number'}
                                name={field.name}
                                id={field.name}
                                placeholder="Please Enter Zip code"
                                value={formValues[field.name]}
                                invalid={!!errors[field.name]}
                                onChange={handleChange}
                              />
                              <FormFeedback>{errors[field.name]}</FormFeedback>
                            </FormGroup>
                          </Col>
                        </Col>
                      </>
                    ))}
                </Row>
                {formData?.length == 0 && <> No Data Found</>}
                {formData?.length > 0 && (
                  <div className="d-flex justify-content-between">
                    <Button
                      style={{ backgroundColor: '#ECE63D', color: '#113B65', borderColor: '#ECE63D', width: '86px', height: '40px' }}
                      type="submit"
                    >
                      {loader ? <Spinner size="sm">Loading...</Spinner> : 'Submit'}
                    </Button>
                  </div>
                )}
              </Form>
            ) : (
              <>
                <Skeleton message={saveMessage} />
              </>
            )}
          </Card>
        </div>
        <FooterComponent />
      </div>
    </>
  );
};

export default CaseLawyer;
